import React from "react";
import {Field} from "react-final-form";
import {
    composeValidators,
    regRequiredValidate,
    regSpecialCharacterValidate,
    regProfanityWordsValidate,
} from "../../../../containers/RegistrationLoginPage/registrationValidation";
import TextField from "../../../HTMLEntities/Textfield";
import {UserName} from "../../../../containers/RegistrationLoginPage/types";
import {errorHandler} from "../../../../containers/RegistrationLoginPage/errorUtils";
interface NameFieldInterface {
    configuration: UserName;
    label?: string;
}
const NameField: React.FC<NameFieldInterface> = ({
    configuration,
    label = "Name",
}: NameFieldInterface) => {
    const {fieldName, editable, selectedValue} = configuration;

    return (
        <Field<string>
            name={fieldName}
            validate={composeValidators(
                regRequiredValidate(`${label} is mandatory`),
                regSpecialCharacterValidate(`${label} cannot have special characters`),
                regProfanityWordsValidate(`${label} contains objected words`),
            )}
            format={(value) =>
                value ? value.replace(/^\s+|\s+$/g, "").replace(/\s+/g, " ") : value
            }
            formatOnBlur={true}
            {...(selectedValue ? {initialValue: selectedValue} : {})}
            validateFields={[]}
        >
            {(props) => {
                return (
                    <TextField
                        placeholder={label}
                        type="text"
                        maxLength={125}
                        autoComplete="off"
                        initialValue={props?.input?.value ?? ""}
                        isFocused={props?.meta?.active ?? false}
                        isFilled={props?.input?.value?.length > 0}
                        error={errorHandler(props?.meta)}
                        isTouched={props?.meta?.touched}
                        inputRFF={props?.input}
                        isDisabled={!editable}
                    />
                );
            }}
        </Field>
    );
};
export default NameField;
